// extracted by mini-css-extract-plugin
module.exports = {"container":"SubpageHero-module--container--2n_u5","text":"SubpageHero-module--text--18G58"};